import { useEffect, useState } from "react";

/**
 * Detects whether the current user is in Nigeria using IP geolocation.
 * Result is cached in localStorage to avoid repeated API calls.
 *
 * Falls back to timezone detection if the API call fails, and defaults
 * to international (false) if both methods are inconclusive.
 */
export const useUserLocation = () => {
  const [isNigerian, setIsNigerian] = useState(null); // null = still detecting
  const [locationLoading, setLocationLoading] = useState(true);

  useEffect(() => {
    const detect = async () => {
      try {
        // Use cached result if available
        const cached = localStorage.getItem("userCountryCode");
        if (cached) {
          setIsNigerian(cached === "NG");
          setLocationLoading(false);
          return;
        }

        const res = await fetch("https://ipapi.co/json/");
        const data = await res.json();
        const code = data?.country_code ?? "";

        localStorage.setItem("userCountryCode", code);
        setIsNigerian(code === "NG");
      } catch {
        // Fallback: browser timezone
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        setIsNigerian(tz === "Africa/Lagos");
      } finally {
        setLocationLoading(false);
      }
    };

    detect();
  }, []);

  return { isNigerian, locationLoading };
};
